
import { Component } from '@angular/core';
import {
  ReactiveFormsModule,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { WidgetBaseFilterComponent } from '@backoffice-frontend/shared/bo/widgets/ui-widget-base-filter';
import { BaseWidgetTypeConfigComponent } from '@clean-code/shared/dashboard/widget/api-widget';
import { PatchFormGroupWithEmitValuesDirective } from '@clean-code/shared/directives/ui-form';
import { TranslocoModule } from '@jsverse/transloco';
import { MarketHknCustomersWidgetTypeConfig } from '../market-hkn-customers';
@Component({
    selector: 'dashboard-market-hkn-customers-config',
    templateUrl: './market-hkn-customers-config.component.html',
    styleUrls: ['./market-hkn-customers-config.component.css'],
    imports: [
        ReactiveFormsModule,
        WidgetBaseFilterComponent,
        PatchFormGroupWithEmitValuesDirective,
        MatCheckboxModule,
        TranslocoModule
    ]
})
export class MarketHknCustomersConfigComponent extends BaseWidgetTypeConfigComponent<MarketHknCustomersWidgetTypeConfig> {
  override form = new UntypedFormGroup({
    filter: new UntypedFormControl(null, [Validators.required]),
    showSumRow: new UntypedFormControl(false),
  });

  public close() {
    // TODO: dashboard state
    // this.callback.next();
  }
}
